import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.active && _vm.registered)?_c(VTooltip,{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('button',_vm._g(_vm._b({staticClass:"gt-fab",attrs:{"aria-label":"Abrir o tour desta página"},on:{"click":_vm.replay}},'button',attrs,false),on),[_c('span',{staticClass:"gt-fab__q"},[_vm._v("?")])])]}}],null,false,3379204002)},[_c('span',[_vm._v("Tour desta página")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }